import { Point } from '@components/FramePolygonSized';
import { CSSProperties, useEffect, useRef, useState } from 'react';

export type PhotoSize = { width: number; height: number };
export type Position = { top: CSSProperties['top']; left: CSSProperties['left'] };
export default function useMenuPosition({
    center,
    containerSize,
    offset = 7,
}: {
    center: Point;
    containerSize: PhotoSize;
    offset?: number;
}) {
    const menuRef = useRef<HTMLDivElement | null>(null);
    const [menuPosition, setMenuPosition] = useState<Position | null>(null);

    useEffect(() => {
        if (!menuRef.current) {
            setMenuPosition(null);
            return;
        }

        const menuSize = {
            width: menuRef.current.offsetWidth,
            height: menuRef.current.offsetHeight,
        };

        const newPos = calculateMenuPosition(center, menuSize, containerSize, offset);
        setMenuPosition(newPos);
    }, [center, containerSize.width, containerSize.height]);

    return { menuRef, menuPosition };
}

const calculateMenuPosition = (center: Point, menuSize: PhotoSize, containerSize: PhotoSize, offset: number) => {
    let left = center.x + offset;
    let top = center.y + offset;

    if (left + menuSize.width > containerSize.width) {
        left = center.x - menuSize.width - offset;
    }

    if (top + menuSize.height > containerSize.height) {
        top = center.y - menuSize.height - offset;
    }

    return {
        top,
        left,
    };
};
